import { render, staticRenderFns } from "./schoolResourcesCategoryList.vue?vue&type=template&id=7e047dde"
import script from "./schoolResourcesCategoryList.vue?vue&type=script&lang=js"
export * from "./schoolResourcesCategoryList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports